import React, { useState, useEffect, useRef } from 'react'

/*
fallbackSrc: loaded instead when src fails, e.g. the 1x image when src is a
`_2x` that may not exist. The placeholder only shows if the fallback fails too.
*/
const PlaceholderImage = ({
  src,
  fallbackSrc,
  height = 160,
  width = 90,
  className = '',
  alt = '',
}) => {
  const [isLoaded, setIsLoaded] = useState(false)
  const [isError, setIsError] = useState(false)
  const [useFallback, setUseFallback] = useState(false)

  // without a fallbackSrc this is always src, so other callers are unchanged
  const currentSrc = useFallback ? fallbackSrc : src

  const imgElement = useRef(null)

  useEffect(() => {
    setUseFallback(false)
  }, [src])

  useEffect(() => {
    setIsLoaded(false)
    const img = imgElement.current
    if (img && img.complete) {
      setIsLoaded(true)
    }
  }, [currentSrc])

  return (
    <>
      {(!isLoaded || isError) && (
        <svg
          viewBox={`0 0 ${width} ${height}`}
          preserveAspectRatio="xMidYMid slice"
        >
          <rect width={width} height={height} fill="#CCC" />
        </svg>
      )}
      {!isError && (
        <img
          ref={imgElement}
          src={currentSrc}
          className={className}
          alt={alt}
          style={!isLoaded ? { visibility: 'hidden', height: '1px' } : {}}
          onLoad={() => setIsLoaded(true)}
          onError={() => {
            if (fallbackSrc && !useFallback) {
              setUseFallback(true)
              return
            }
            console.log('image error')
            setIsError(true)
          }}
        />
      )}
    </>
  )
}

export default PlaceholderImage
